import { NoteModule } from '@/api/notes/types';
import { DEALS_TAB_KEYS } from '@/routes/deals-tabs';
import { PagePaths } from '@/routes/page-paths';

/** Query-param key that opens a deal board card's detail drawer. */
export const DEAL_BOARD_CARD_PARAM = 'card';

/**
 * Route for the object a note was written on. The aggregated notes feed returns
 * only `module` + object id by design — the backend has no knowledge of frontend
 * paths, which is what lets a new Notes-adopting module appear in the feed
 * without changing the response shape. So the mapping lives here.
 *
 * Returns `null` for a module this client does not know how to route to yet;
 * callers render the object name as plain text in that case.
 */
export function buildNoteObjectPath(module: NoteModule, objectId: string): string | null {
  switch (module) {
    case 'Fund':
      return `${PagePaths.allFunds}/${objectId}`;
    case 'AddressBook':
      return `${PagePaths.addressBook}/contact/${objectId}`;
    case 'Deal':
      return `${PagePaths.deals}?tab=${DEALS_TAB_KEYS.PIPELINE}&${new URLSearchParams({ [DEAL_BOARD_CARD_PARAM]: objectId })}`;
    default:
      return null;
  }
}
